export default __webpack_public_path__ + "45f71323daa3b9cf4c13183d66b969d0.svg";